<template>
    <div class="container -home">
        <h1>Gescomi&nbsp;2</h1>

        <div class="row">
            <div class="col-sm-4">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Membres
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Gérer les membres, les échanges avec les membres,
                            leurs contrats, etc.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'clients'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les membres
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Documents
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Définir les types de documents existants et mettre
                            en ligne les modèles.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'document-types'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les documents
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Process
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Quels sont les process dans la gestion des contrats, et quelles sont
                            les actions associées ?
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'processes'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les process
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Producteurs
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Liste des producteurs qu'il est possible d'associer à un contrat.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'producers'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les producteurs
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Companies
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            La liste des compagnies existantes et des types de contrat associés.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'companies'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les compagnies
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Borderaux
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Saisir les bordereaux de commissions.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'sheet-list'}"
                               class="btn btn-primary">
                                &rightarrow; Saisir les bordereaux
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4" v-if="isStaff">
                <div class="panel panel-default -clients">
                    <div class="panel-heading">
                        Contrats Dissociés
                    </div>
                    <div class="panel-body">
                        <p class="panel-text">
                            Liste des contrats dissociés qu'il est possible d'associer au site.
                        </p>
                        <p class="cta">
                            <a v-link="{'name': 'unlinked-contracts'}"
                               class="btn btn-primary">
                                &rightarrow; Gérer les contrats dissociés
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import '~src/style/variables';

    .cta {
        margin-top: @grid-gutter-width;
        text-align: right;
    }

    .panel-text {
        height: 40px
    }
</style>

<script type="text/ecmascript-6">
    import api from '../api/core';

    export default {
        data() {
            return {
                isStaff: api.isStaff(),
                partnerCode: api.getPartnerCode()
            };
        }
    };
</script>



// WEBPACK FOOTER //
// Home.vue?2837ef25